module.exports = __webpack_public_path__ + "static/media/meeting-accepted-black.80331f65.svg";